<template>
  <div class="aviso-informativo" :class="['aviso-informativo-' + variante, {'aviso-informativo-sutil': sutil}]" :role="variante === 'vermelho' ? 'alert' : 'status'">
    <div class="aviso-informativo-icone" aria-hidden="true" v-if="mostrarIcone && !sutil && !['amarelo', 'vermelho'].includes(variante)">
      <i class="fa fa-info-circle"></i>
    </div>
    <div class="aviso-informativo-conteudo">
      <h6 class="aviso-informativo-titulo" v-if="title">{{ title }}</h6>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvisoInformativo',
  props: {
    title: String,
    variante: {
      type: String,
      default: 'tema',
      validator: valor => ['tema', 'cinza', 'amarelo', 'vermelho'].includes(valor)
    },
    sutil: {
      type: Boolean,
      default: false
    },
    mostrarIcone: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.aviso-informativo {
  --aviso-icone: var(--lecard-primary);
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid #e3e6e9;
  border-radius: 16px;
  box-shadow: var(--shadow);
  color: #2f3747;
  background-color: #fff;
}

.aviso-informativo-cinza {
  --aviso-icone: #7b8290;
  background-color: #f4f5f7;
  border-color: #e3e6e9;
}

.aviso-informativo-amarelo,
.aviso-informativo-vermelho {
  justify-content: center;
  padding: 12px 14px;
  border: 0;
  box-shadow: none;
  color: #856b32;
  background-color: #fff9ed;
  text-align: center;
}

.aviso-informativo-vermelho {
  color: #a52a35;
  background-color: #fff0f1;
}

.aviso-informativo-vermelho .aviso-informativo-titulo,
.aviso-informativo-vermelho .aviso-informativo-conteudo ::v-deep p,
.aviso-informativo-amarelo .aviso-informativo-titulo,
.aviso-informativo-amarelo .aviso-informativo-conteudo ::v-deep p {
  color: inherit;
}

.aviso-informativo-icone {
  display: flex;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin-right: 12px;
  align-items: center;
  justify-content: center;
  color: var(--aviso-icone);
  font-size: 20px;
}

.aviso-informativo-conteudo {
  min-width: 0;
  overflow-wrap: anywhere;
}

.aviso-informativo-titulo {
  margin: 0;
  color: #202736;
  font-weight: 700;
}

.aviso-informativo-conteudo ::v-deep p {
  color: #7b8290;
  line-height: 1.35;
}

.aviso-informativo-conteudo ::v-deep p:last-child {
  margin-bottom: 0;
}

.aviso-informativo-sutil {
  justify-content: center;
  padding: 12px 14px;
  text-align: center;
}
</style>
